import Vue from "vue";
import router from "@/router"
import store from "@/store";

Vue.prototype.hasPermission = permission => {
    const permissions = store.state.user.permissions;
    return permissions.indexOf(permission) !== -1;
};

// it must be a permission, it used for disable notifications and toolbar actions
Vue.prototype.airportAgency = (roles = null) => {
    try {
        return store.state.user && [11, 12].includes(store.state.user.roles[0].id);
    } catch (e) {
        return roles ? [11, 12].includes(roles[0].id) : false
    }
};

Vue.directive('redirect-if-no-permission', (el, {arg, binding = {name: 'Dashboard'}}) => {
    if (!arg)
        console.warn('[Wasilni] No argument was given to redirect-if-no-permission');
    if (!Vue.prototype.hasPermission(arg))
        router.push(binding);
});
